import { Box, Text, Link } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const GeneralInfo = () => {
  const { t } = useTranslation(['integrations']);

  useEffect(() => {
    const script1 = document.createElement('script');
    const script2 = document.createElement('script');
    script1.src = 'https://timeero.wistia.com/medias/0an7wdzo78';
    script1.async = true;
    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script2.async = true;
    document.body.appendChild(script1);
    document.body.appendChild(script2);

    return () => {
      if (script1 && document.body.contains(script1)) {
        document.body.removeChild(script1);
      }
      if (script2 && document.body.contains(script2)) {
        document.body.removeChild(script2);
      }
    };
  }, []);

  return (
    <Box>
      <Box mb={12}>
        <Text fontSize="md" fontWeight={600}>
          {t('integrations:overview')}
        </Text>
        <Text fontSize="xs">{t('integrations:gusto.overviewContent')}</Text>
      </Box>
      <Box mb={12}>
        <Text fontSize="md" fontWeight={600}>
          {t('integrations:whatHeading')}
        </Text>
        <Text fontSize="xs">{t('integrations:gusto.whatHeadingContent')}</Text>
        <Link
          href="https://help.timeero.com/gusto-integration"
          color="secondary.500"
          fontSize="xs"
          fontWeight="semibold"
          isExternal
        >
          {t('integrations:learnToStart')}
        </Link>
      </Box>
      <Box width={{ base: '75%', md: '450px', lg: '600px', xl: '750px' }}>
        <div
          className="wistia_embed wistia_async_0an7wdzo78 videoFoam=true"
          style={{ height: '100%', width: '100%' }}
        />
      </Box>
    </Box>
  );
};
export default GeneralInfo;
